import { useTranslation } from "react-i18next";
import HeaderImage from "../../../../assets/images/body/home.png";
import { useLayout } from "../../../../context/LayoutContext";
import styles from "./style.module.scss";

const HeaderSection = () => {
  const { t } = useTranslation();
  const { getPadding } = useLayout();
  return (
    <section
      className={styles.headerContainer}
      style={{ paddingLeft: getPadding(), paddingRight: getPadding() }}
    >
      <div className={styles.titleContainer}>
        <text className={styles.title1}>{t("header.title1")}</text>
        <text className={styles.title2}>{t("header.title2")}</text>
        <text className={styles.subtitle}>{t("header.subtitle")}</text>
      </div>
      <img className={styles.image} src={HeaderImage} />
    </section>
  );
};

export default HeaderSection;
